// extracted by mini-css-extract-plugin
export var form = "_bv-0";